module.exports = __webpack_public_path__ + "img/50004.e05b7501.png";